import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaUser, FaArrowLeft, FaFacebook, FaTwitter, FaLinkedin, FaShareAlt } from 'react-icons/fa';
import { blogs } from '../data/blogs';

const BlogDetailsPage = () => {
    const { id } = useParams();
    const blog = blogs.find(b => b.id === parseInt(id));

    if (!blog) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="text-center">
                    <h1 className="text-6xl font-bold text-slate-300 mb-4">404</h1>
                    <p className="text-xl text-slate-600 mb-8">Blog post not found.</p>
                    <Link to="/blog" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                        Back to Articles
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white font-sans text-slate-900 pt-20">
            {/* Progress Bar (Optional, can add later) */}

            <article className="max-w-4xl mx-auto px-6 lg:px-12 py-16">
                {/* Back Link */}
                <Link to="/blog" className="inline-flex items-center text-slate-500 hover:text-blue-600 transition-colors mb-8 text-sm font-medium group">
                    <FaArrowLeft className="mr-2 group-hover:-translate-x-1 transition-transform" /> Back to Blog
                </Link>

                {/* Header */}
                <header className="mb-12">
                    <div className="flex items-center gap-4 text-sm text-slate-500 mb-6 uppercase tracking-wider font-bold">
                        <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs">Technology</span>
                        <div className="flex items-center gap-2">
                            <FaCalendarAlt /> {blog.date}
                        </div>
                    </div>
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-8"
                    >
                        {blog.title}
                    </motion.h1>

                    <div className="flex items-center justify-between border-y border-slate-100 py-6">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-full bg-slate-200 flex items-center justify-center text-xl text-slate-500">
                                <FaUser />
                            </div>
                            <div>
                                <div className="font-bold text-slate-900">{blog.author}</div>
                                <div className="text-xs text-slate-500 uppercase tracking-widest">Tech Inovant</div>
                            </div>
                        </div>
                        <div className="flex gap-4 text-slate-400">
                            <button className="hover:text-blue-600 transition-colors"><FaFacebook size={18} /></button>
                            <button className="hover:text-cyan-500 transition-colors"><FaTwitter size={18} /></button>
                            <button className="hover:text-blue-700 transition-colors"><FaLinkedin size={18} /></button>
                            <button className="hover:text-slate-600 transition-colors"><FaShareAlt size={18} /></button>
                        </div>
                    </div>
                </header>

                {/* Content */}
                <div className="prose prose-lg prose-slate max-w-none mb-16">
                    {/* Featured Image */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6 }}
                        className="rounded-2xl overflow-hidden shadow-lg mb-12"
                    >
                        <img src={blog.image} alt={blog.title} className="w-full object-cover" />
                    </motion.div>

                    {/* Blog Body - Using dangerouslySetInnerHTML carefully since content is static from our data file */}
                    <div dangerouslySetInnerHTML={{ __html: blog.content }}></div>
                </div>

                {/* Author Bio / CTA */}
                <div className="bg-slate-50 rounded-2xl p-8 md:p-12 border border-slate-100 text-center">
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">Enjoyed this article?</h3>
                    <p className="text-slate-600 mb-8 max-w-lg mx-auto">Subscribe to our newsletter to get the latest insights on technology and innovation delivered straight to your inbox.</p>
                    <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                        <input type="email" placeholder="Enter your email" className="flex-1 px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 outline-none" />
                        <button className="px-6 py-3 bg-slate-900 text-white font-bold rounded-lg hover:bg-slate-800 transition-colors">Subscribe</button>
                    </form>
                </div>

            </article>
        </div>
    );
};

export default BlogDetailsPage;
